import {
  UsergroupAddOutlined,
  UserOutlined,
  ReadOutlined,
  MessageFilled,
  WhatsAppOutlined,
} from "@ant-design/icons";
import "./index.css";
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import {
  BiCreditCard,
  BiDownArrowAlt,
  BiUpArrowAlt,
} from "react-icons/bi";
import { Divider } from "antd";

const partyHeaders = [
  {
    label: "All Parties",
    key: "1",
    icon: <UsergroupAddOutlined />,
    parties: "1",
    color: "blue",
  },
  {
    label: "To Collect",
    key: "2",
    icon: <HiOutlineCurrencyRupee size={16} />,
    amount: "₹ 0",
    color: "green",
  },
  // {
  //   label: "To Pay",
  //   key: "3",
  //   icon: <HiOutlineCurrencyRupee size={16} />,
  //   amount: "₹ 0",
  //   color: "red",
  // },
];

const dashboardHeaders = [
  {
    label: "To Collect",
    key: "1",
    icon: <BiUpArrowAlt size={22} />,
    amount: "₹ 0",
    color: "green",
  },
  {
    label: "To Pay",
    key: "2",
    icon: <BiDownArrowAlt size={22} />,
    amount: "₹ 0",
    color: "red",
  },
];
const partySelectHeaders = [
  {
    label: "Cash Sale",
    key: "1",
    amount: "₹ 1200",
    mode: "credit",
    color: "blue",
  },
  {
    label: "Faisal",
    key: "2",
    amount: "₹ 600",
    mode: "debit",
    color: "green",
  },
  {
    label: "Karthick",
    key: "3",
    amount: "₹ 250",
    mode: "credit",
    color: "red",
  },
];

const itemHeaders = [
  {
    key: "itemName",
    title: "Item Name",
    dataIndex: "itemName",
    sorter: (a, b) => a.date.length - b.date.length,
  },
  {
    key: "itemCode",
    title: "Item Code",
    dataIndex: "itemCode",
  },
  {
    key: "stockQTY",
    title: "Sales Quantity",
    dataIndex: "stockQTY",
  },
  {
    key: "salesPrice",
    title: "Sales Amount",
    dataIndex: "salesPrice",
    sorter: (a, b) => a.salesPrice.length - b.salesPrice.length,
  },
  {
    key: "categoryName",
    title: "Category Name",
    dataIndex: "categoryName",
  },
  {
    key: "purchasePrice",
    title: "purchase Amount",
    dataIndex: "purchasePrice",
    sorter: (a, b) => a.purchasePrice.length - b.purchasePrice.length,
  },
];

const itemTableList = [
  {
    itemName: "Crab",
    itemCode: "-",
    salesQuantity: "3.0 PCS",
    salesAmount: "₹ 1,600",
    purchaseQuantity: "3.0 PCS",
    purchaseAmount: "₹ 1,350",
  },
  {
    itemName: "Fish",
    itemCode: "-",
    salesQuantity: "2.0 PCS",
    salesAmount: "₹ 2,800",
    purchaseQuantity: "1.0 PCS",
    purchaseAmount: "₹ 1,000",
  },
  {
    itemName: "Kadaknath Eggs",
    itemCode: "-",
    salesQuantity: "0.0 PCS",
    salesAmount: "-",
    purchaseQuantity: "100.0 PCS",
    purchaseAmount: "₹ 1,600",
  },
];

const ledgerStatementDetails = [
  {
    date: "",
    voucher: "Opening Balance",
    sNo: "-",
    key: "1",
    credit: "-",
    debit: "-",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "0.0",
  },
  {
    date: "06 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "1	",
    key: "2",
    credit: "75.0	",
    debit: "375.0",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "300",
  },
  {
    date: "07 Aug 2024",
    voucher: "Purchase Record",
    sNo: "4",
    key: "3",
    credit: "900.0",
    debit: "_",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-600",
  },
  {
    date: "08 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "6",
    key: "4",
    credit: "-",
    debit: "_",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-600",
  },
  {
    date: "12 Aug 2024",
    voucher: "Sales Invoice",
    sNo: "7",
    key: "5",
    credit: "-",
    debit: "125.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-475",
  },
  {
    date: "14 Aug 2024",
    voucher: "Payment out",
    sNo: "2",
    key: "6",
    credit: "-",
    debit: "900.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "425",
  },
  {
    date: "14 Aug 2024",
    voucher: "Payment In",
    sNo: "4",
    key: "",
    credit: "825.0",
    debit: "900.0",
    tdsDeductParty: "_",
    tdsDeductSelf: "_",
    balance: "-400",
  },
  {
    date: "",
    voucher: "Closing Balance",
    sNo: "-",
    key: "1",
    credit: "350",
    debit: "-",
    tdsDeductParty: "-",
    tdsDeductSelf: "-",
    balance: "-350",
  },
];

const partySelectTabs = [
  {
    label: "Transactions",
    key: "1",
    icon: <BiCreditCard size={18} />,
  },
  {
    label: "Profile",
    key: "2",
    icon: <UserOutlined className="text-[16px]" />,
  },
  {
    label: "Ledger (Statement)",
    key: "3",
    icon: <ReadOutlined className="text-[16px]" />,
  },
  {
    label: "Item Wise Report",
    key: "4",
    icon: <ReadOutlined className="text-[16px]" />,
  },
];
const partySelectItems = [
  {
    label: <a href="/parties/data">Sales Invoice</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/payment-in">Payment In</a>,
    key: "2",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Quotation</a>,
    key: "3",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Proforma Invoice</a>,
    key: "4",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Sales Return</a>,
    key: "5",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Delivery Challan</a>,
    key: "6",
  },
  {
    type: "divider",
  },
  {
    label: <a href="/parties/data">Purchase Order</a>,
    key: "7",
  },
];
const transactionsList = [
  {
    label: "Sales Invoice",
    key: "1",
  },

  {
    label: "Payment In",
    key: "2",
  },

  {
    label: "Quotation",
    key: "3",
  },

  {
    label: "Proforma Invoice",
    key: "4",
  },
  {
    label: "Sales Return",
    key: "5",
  },

  {
    label: "Delivery Challan",
    key: "6",
  },

  {
    label: "Purchase Order",
    key: "7",
  },
];
const items = [
  {
    label: <a href="/reports/party-wise-outstanding">Partywise Outstanding</a>,
    key: "1",
  },
  {
    type: "divider",
  },
  {
    label: (
      <a href="/reports/sales-item-quantity-report">Item Report By Party</a>
    ),
    key: "2",
  },
];

const ledgerStatementList = (
  <div className="hover:rounded-md hover:mr-[-3px] flex justify-between w-[130px] h-[60px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
    <div>
      <p className="flex border-x-0 border-t-0 text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <MessageFilled className="mr-1" />
          SMS
        </a>
      </p>
      <Divider className="w-[185%] mt-[4px] ml-[-24px]" />
      <p className="flex mt-[-20px] text-[14px] font-semibold">
        <a href="/parties" className="flex">
          <WhatsAppOutlined className="mr-1" />
          Whatsapp
        </a>
      </p>
    </div>
  </div>
);
const balaceCollectOptions = [
  {
    label: "To Collect",
    value: "To Collect",
  },
  // {
  //   label: "To Pay",
  //   value: "To Pay",
  // },
];
const partyFaqList = [
  {
    key: "1",
    label: "Why should I create Parties?",
    children: (
      <p className="text-[12px]">
        Parties are your Customers and Suppliers. To make bills for them, you
        need to add them as a party first.
      </p>
    ),
  },
  {
    key: "2",
    label: "I have too many parties. How to add them easily?",
    children: (
      <p className="text-[12px]">
        myBillBook provides the option to import your parties data from Excel.{" "}
        To start uploading your parties in bulk click here.
      </p>
    ),
  },
  {
    key: "3",
    label: "How to see Party Ledger/Statement?",
    children: (
      <p className="text-[12px]">
        A party's ledger can be seen in two ways: <br />
        1. Select the party in the Parties table and then click on the
        "Ledger(Statement)" tab given at top in the new screen that opens.{" "}
        <br />
        2. You can also open Party Statement by going to Reports from the side
        navigation menu and selecting "Party Statement (Ledger)". After that,
        you can select the party whose Party Statement you want to see.
      </p>
    ),
  },
  {
    key: "4",
    label: "How is Party balance calculated?",
    children: (
      <p className="text-[12px]">
        Party balance is the outstanding amount of money that you need to
        collect from or pay to the party. It is calculated based on the Opening
        Balance you entered while creating the party, the invoices(both sales
        and purchase) you made against the party and the payments you made
        to/received from the party.
      </p>
    ),
  },
  {
    key: "5",
    label: "How to send Invoice SMS to Party?",
    children: (
      <p className="text-[12px]">
        For every Invoice that you create, an SMS is sent automatically to your
        party with a link to that Invoice. Incase you want to turn this feature
        off, you can do that by going to Reminder inside Settings and disabling
        the "Send billing SMS to Party" option. To manually send SMS to Party,
        open the Invoice and click on the SMS button.
      </p>
    ),
  },
  {
    key: "6",
    label: "How to create GST/Non-GST party?",
    children: (
      <p className="text-[12px]">
        While creating a party, enter their GSTIN. Accordingly that party will
        be counted as GST/Non-GST Party. GSTIN along with Place of Supply of
        party will determine whether an Invoice will have IGST or CGST/SGST so
        make sure you fill this information.
      </p>
    ),
  },
];
const partyTypeOptions = [
  {
    label: "Customer",
    value: "customer",
  },
  {
    label: "Supplier",
    value: "supplier",
  },
];

export {
  items,
  partyHeaders,
  balaceCollectOptions,
  // TableData,
  partyTypeOptions,
  dashboardHeaders,
  // HeaderData,
  partySelectTabs,
  partySelectHeaders,
  partySelectItems,
  transactionsList,
  ledgerStatementDetails,
  itemHeaders,
  itemTableList,
  ledgerStatementList,
  partyFaqList,
};
